import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css';

class ShopTheLook extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initGalleries();
  }

  initGalleries() {
    const mainGalleries = this.querySelectorAll('.shop-the-look-gallery');
    const thumbnailGalleries = this.querySelectorAll('.shop-the-look-thumbnail');

    if (!mainGalleries.length || !thumbnailGalleries.length) return;

    mainGalleries.forEach((mainGalleryElement, index) => {
      if (index >= thumbnailGalleries.length) return;

      const mainGallery = new Splide(mainGalleryElement, {
        speed: 600,
        rewind: true,
        pagination: false,
        arrows: false,
        keyboard: 'focused',
      });

      const thumbnailsGallery = new Splide(thumbnailGalleries[index], {
        fixedWidth: 44,
        fixedHeight: 44,
        gap: 0,
        rewind: true,
        pagination: false,
        arrows: false,
        keyboard: 'focused',
        mediaQuery: 'min',
        isNavigation: true,
        paginationKeyboard: true,
        breakpoints: {
          1024: {
            fixedWidth: 60,
            fixedHeight: 60,
          },
        },
      });

      mainGallery.mount();
      thumbnailsGallery.mount();

      mainGallery.on('moved', (newIndex) => {
        thumbnailsGallery.go(newIndex);
        this.updateActiveThumbnail(thumbnailsGallery.Components.Elements.slides, newIndex);
      });

      const thumbnailSlides = thumbnailsGallery.Components.Elements.slides;

      thumbnailSlides.forEach((thumb, i) => {
        thumb.dataset.index = i;

        thumb.setAttribute('tabindex', '0');

        thumb.addEventListener('click', () => {
          mainGallery.go(i);
          this.updateActiveThumbnail(thumbnailSlides, i);
        });

        if (window.matchMedia('(hover: hover)').matches) {
          thumb.addEventListener('mouseenter', () => {
            mainGallery.go(i);
            this.updateActiveThumbnail(thumbnailSlides, i);
          });
        }

        thumb.addEventListener('focus', () => {
          mainGallery.go(i);
          this.updateActiveThumbnail(thumbnailSlides, i);
        });
      });

      this.updateActiveThumbnail(thumbnailSlides, 0);
    });
  }

  updateActiveThumbnail(thumbnailSlides, activeIndex) {
    thumbnailSlides.forEach((thumb) => thumb.classList.remove('active'));

    if (thumbnailSlides[activeIndex]) {
      thumbnailSlides[activeIndex].classList.add('active');
    }
  }
}

customElements.define('shop-the-look', ShopTheLook);
